<section>
  <div class="container-fluid">
    <div class="row mt-2 border Page-Header">
      <h6 class="HeadContent">
        <span class="p-2"
          >Admin - Course Management - {{ courseMode }} Course
        </span>
      </h6>
    </div>

    <form [formGroup]="addCourseForm" (ngSubmit)="formSubmit()">
      <div class="row">
        <div class="col-md-12">
          <div class="position-relative mt-1">
                  <div class="card my-2" *ngIf="!examAgencyRequestParam.coursePlanId">
        <div class="card-header header-clone text-white text-uppercase fw-bold">
          Clone From Previous Course
        </div>
            <div class="col-md-11">

            <div class="row g-3 align-items-center">



              <!-- Course Master -->
              <div class="col-md-6">
                <div class="row g-2 align-items-center">
                  <label for="courseMaster" class="col-sm-2 col-form-label text-sm-end">Course Master</label>
                  <div class="col-sm-10">
                    <div class="input-group input-group-sm d-flex gap-2">
                      <input
                        id="courseMaster"
                        type="text"
                        formControlName="courseMaster"
                        class="form-control"
                      />

                    </div>
                  </div>
                </div>
              </div>
                            <!-- Clone From -->
              <div class="col-md-6">
                <div class="row g-2 align-items-center">
                  <label for="cloneFrom" class="col-sm-2 col-form-label text-sm-end">Clone From</label>
                  <div class="col-sm-10">
                    <div class="input-group input-group-sm d-flex gap-2">
                    <select
                      id="cloneFrom"
                      class="form-select form-select-sm"
                      [formControl]="selectedCourse"
                      (change)="getCourseById()"
                    >
                      <option *ngIf="!courseList?.length" [ngValue]="null" disabled>No courses available</option>
                      <option *ngIf="courseList?.length" [ngValue]="null" disabled [selected]="!selectedCourse.value">
                        Select a course
                      </option>
                      <option *ngFor="let code of courseList" [ngValue]="code.Course_Id">
                        {{ code.Exam_Year }} — {{ code.Course_Name }}
                      </option>
                    </select>
                    <button
                        *ngIf="courseMode === 'Add' && selectedCourse.value"
                        type="button"
                        class="btn btn-outline-secondary"
                        (click)="ClearClone()"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </div>
          </div>

          <div class="row" >
            <div class="col-md-6">

              <div class="row">
                <!-- First Column -->
                <div class="col-md-6">
                  <!-- <div class="row">
                    <div
                      class="col-md-5 d-flex max-space-height p-0 "
                    >
                      <div class="p-0">Clone From</div>
                    </div>
                    <div class="col-md-6 max-space-height ">
                      <select
                        class="form-control form-control-sm inputfield-txt"
                        (change)="getCourseById()"
                        [formControl]="selectedCourse"
                      >
                        <option hidden>Choose Course to Clone ...</option>
                        <option
                          class="border-bottom"
                          *ngFor="let code of courseList"
                          [value]="code.Course_Id"
                        >
                          {{ code.Course_Name }}
                        </option>
                      </select>
                    </div>
                  </div> -->

                  <div class="row align-items-center max-space-height" style="    margin-top: 6px;">
                    <label class="col-md-5  px-md-0 col-form-label d-flex text-md-end justify-content-md-end position-relative">
                       Course Name <span class="text-danger required-stars">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <input
                        type="text"
                        [title]="addCourseForm.get('courseName')?.value"
                        formControlName="courseName"
                        class="form-control form-control-sm"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('courseName')?.touched &&
                            addCourseForm.get('courseName')?.invalid
                        }"
                      />
                    </div>
                   </div>
                   <div class="row  align-items-center max-space-height ">
                    <label class="col-md-5 px-md-0 d-flex align-items-center  justify-content-md-end position-relative text-md-end">
                       Exam Short Name <span class="text-danger required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <input
                        type="text"
                        formControlName="examShortName"
                        class="form-control form-control-sm"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('examShortName')?.touched &&
                            addCourseForm.get('examShortName')?.invalid
                        }"
                      />
                    </div>
                  </div>

                  <!-- <div class="row">
                    <div class="col-md-6 d-flex max-space-height">
                      <div class="p-0">Exam Year</div>
                    </div>
                    <div class="col-md-5 max-space-height">
                      <input
                        formControlName="examYear"
                        type="number"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                      />
                    </div>
                  </div> -->
                  <div class="row align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-end text-sm-end position-relative">
                       Course Category Type <span class="text-danger required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-select form-select-sm"
                        formControlName="courseCategoryType"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('courseCategoryType')?.touched &&
                            addCourseForm.get('courseCategoryType')?.invalid
                        }"
                      >
                        <option hidden></option>
                        <option
                          *ngFor="let code of courseCategoryType"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row  align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-md-end position-relative">
                      Exam Level  <span class="text-danger  required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-control form-control-sm inputfield-txt"
                        formControlName="examLevel"
                        [ngClass]="
                          addCourseForm.get('examLevel')?.touched &&
                          addCourseForm.get('examLevel')?.invalid
                            ? 'red-border-required'
                            : ''
                        "
                      >
                        <option hidden></option>
                        <option
                          class="border-bottom"
                          *ngFor="let code of examLevelType"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-md-end position-relative text-md-end">
                      Exam Difficulty Level  <span class="text-danger required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-control form-control-sm inputfield-txt"
                        formControlName="examDifficultyLevel"
                        [ngClass]="
                          addCourseForm.get('examDifficultyLevel')?.touched &&
                          addCourseForm.get('examDifficultyLevel')?.invalid
                            ? 'red-border-required'
                            : ''
                        "
                      >
                        <option hidden></option>
                        <option
                          class="border-bottom"
                          *ngFor="let code of examDifficultLevelType"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>

                                    <div class="row align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 justify-content-md-end d-flex align-items-center justify-content-end position-relative">
                       Exam Year <span class="text-danger required-star ms-1">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-select form-select-sm"
                        formControlName="examYear"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('examYear')?.touched &&
                            addCourseForm.get('examYear')?.invalid
                        }"
                      >
                        <option hidden></option>
                        <option
                          *ngFor="let code of yearsList"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 justify-content-md-end d-flex align-items-center justify-content-end position-relative">
                       Exam Month
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-select form-select-sm"
                        formControlName="examMonth"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('examMonth')?.touched &&
                            addCourseForm.get('examMonth')?.invalid
                        }"
                      >
                        <option
                          *ngFor="let month of months"
                          [value]="month.value"
                        >
                          {{ month.label }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 py-0 d-flex align-items-center justify-content-end
                     text-md-end position-relative">
                       Course Delivery Type <span class="text-danger required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-select form-select-sm"
                        formControlName="courseDeliveryType"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('courseDeliveryType')?.touched &&
                            addCourseForm.get('courseDeliveryType')?.invalid
                        }"
                      >
                        <option hidden></option>
                        <option
                          *ngFor="let code of courseDeliveryType"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row  align-items-center max-space-height mt-1 ">
                    <label class="col-md-5 px-md-0 d-flex align-items-center position-relative justify-content-end text-md-end">
                       Availability Start Date <span class="text-danger required-star ">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                    <input
                      type="date"
                      formControlName="courseAvailabilityStartDate"
                      class="form-control form-control-sm"
                      [attr.min]="today"
                      (change)="onStartDateChange()"
                      [ngClass]="{
                        'red-border-required':
                          addCourseForm.get('courseAvailabilityStartDate')?.touched &&
                          addCourseForm.get('courseAvailabilityStartDate')?.invalid
                      }"
                    />
                    </div>
                  </div>

                  <div class="row align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 d-flex align-items-center text-md-end justify-content-end position-relative">
                      Availability End Date <span class="text-danger required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <input
                        type="date"
                        formControlName="courseAvailabilityEndDate"
                        class="form-control form-control-sm"
                        [attr.min]="minEndDate"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('courseAvailabilityEndDate')?.touched &&
                            addCourseForm.get('courseAvailabilityEndDate')?.invalid
                        }"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center max-space-height mt-1">
                    <label class="col-md-5 px-md-0 text-md-end d-flex align-items-center justify-content-end">
                      Number of Trial Days
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <input
                        formControlName="numberOfTrailDays"
                        type="number"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm"
                      />
                    </div>
                  </div>

                  <div class="row align-items-center mt-1">
                    <label class="col-md-5 px-md-0 justify-content-md-end d-flex align-items-center position-relative text-md-end">
                       Course Status Type <span class="text-danger required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-select form-select-sm"
                        formControlName="courseStatusType"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('courseStatusType')?.touched &&
                            addCourseForm.get('courseStatusType')?.invalid
                        }"
                      >
                        <option hidden></option>
                        <option
                          *ngFor="let code of courseStatusType"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row  align-items-center mt-1">
                    <label class="col-md-5 px-md-0 justify-content-md-end d-flex align-items-center position-relative">
                       Location <span class="text-danger  required-star">*</span>
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <select
                        class="form-select form-select-sm"
                        formControlName="location"
                        [ngClass]="{
                          'red-border-required':
                            addCourseForm.get('location')?.touched &&
                            addCourseForm.get('location')?.invalid
                        }"
                      >
                        <option hidden></option>
                        <option
                          *ngFor="let code of locationCode"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row  align-items-center mt-1">
                    <label class="col-md-5 px-md-0 justify-content-md-end d-flex align-items-center text-md-end">
                      Subscription Count
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <input
                        type="number"
                        formControlName="subscriptionCount"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                      />
                    </div>
                  </div>

                  <div class="row  align-items-center mt-1">
                    <label class="col-md-5 px-md-0 justify-content-md-end d-flex align-items-center">
                      Course Rating
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <input
                        type="text"
                        formControlName="courseRating"
                        [appTwoDigitDecimaNumber]="4"
                        onKeyPress="if(this.value.length==10) return false;"
                        class="form-control form-control-sm input-txt text-md-end"
                        [max]="9.9"
                      />
                    </div>
                  </div>
                </div>
                <!-- Second Column -->
                <div class="col-md-6">
                  <div class="m-2">
                    <div class="">

                  <div class="row align-items-center mt-1">
                    <label class="col-md-5 px-md-0 justify-content-md-end d-flex align-items-center">
                      Notification URL
                    </label>
                    <div class="col-md-6 col-sm-12">
                      <input
                        formControlName="notificationUrl"
                        type="text"
                        class="form-control form-control-sm input-txt"
                      />
                    </div>
                  </div>

                      <div class="row align-items-center mt-1" >
                        <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-md-end text-md-end">
                          Notification Date
                        </label>
                        <div class="col-md-6 col-sm-12">
                          <input
                            type="date"
                            formControlName="notificationDate"
                            class="form-control form-control-sm input-txt"
                          />
                        </div>
                      </div>

                      <div class="row align-items-center max-space-height mt-1">
                        <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-end text-md-end">
                          Application Due Date
                        </label>
                        <div class="col-md-6 col-sm-12">
                          <input
                            type="date"
                            formControlName="applicationDueDate"
                            class="form-control form-control-sm input-txt"
                          />
                        </div>
                      </div>

                      <div class="row align-items-center max-space-height mt-1" >
                        <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-end text-md-end">
                          Scheduled Exam Date
                        </label>
                        <div class="col-md-6 col-sm-12">
                          <input
                            type="date"
                            formControlName="scheduledExamDate"
                            class="form-control form-control-sm input-txt"
                          />
                        </div>
                      </div>

                      <div class="row align-items-center max-space-height mt-1">
                        <label class="col-md-5 px-md-0 d-flex align-items-center text-md-end justify-content-md-end justify-content-end">
                          Actual Exam Date
                        </label>
                        <div class="col-md-6 col-sm-12">
                          <input
                            type="date"
                            formControlName="actualExamDate"
                            class="form-control form-control-sm input-txt"
                          />
                        </div>
                      </div>

                      <div class="row align-items-center max-space-height mt-1">
                        <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-end text-md-end">
                          Result Expected Date
                        </label>
                        <div class="col-md-6 col-sm-12">
                          <input
                            type="date"
                            formControlName="resultExpectedDate"
                            class="form-control form-control-sm input-txt"
                          />
                        </div>
                      </div>

                      <div class="row align-items-center max-space-height mt-1">
                        <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-end text-md-end">
                          Result Published Date
                        </label>
                        <div class="col-md-6 col-sm-12">
                          <input
                            type="date"
                            formControlName="resultPublishedDate"
                            class="form-control form-control-sm input-txt"
                          />
                        </div>
                      </div>

                      <div class="row align-items-center max-space-height mt-1">
                        <label class="col-md-5 px-md-0 d-flex align-items-center justify-content-end text-md-end">
                          Exam Duration in Min
                        </label>
                        <div class="col-md-6 col-sm-12">
                          <input
                            type="number"
                            formControlName="examDurationInMinutes"
                            onKeyPress="if(this.value.length==10) return false;"
                            class="form-control form-control-sm input-txt"
                            (keypress)="preventEnteringString($event, 10)"
                          />
                        </div>
                      </div>

                      <div class="row">
                        <div
                          class="col-md-5 d-flex justify-content-end max-space-height px-0"
                        >
                          <div class="p-0 text-md-end">Allow Back Navigation in Test ?</div>
                        </div>
                        <div class="col-md-6 max-space-height">
                          <input
                            type="checkbox"
                            formControlName="allBackNavigationInTest"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col-md-5 d-flex justify-content-end max-space-height px-0"
                        >
                          <div class="p-0 text-md-end">Allow Skipping Question ?</div>
                        </div>
                        <div class="col-md-6 max-space-height ">
                          <input
                            type="checkbox"
                            formControlName="allowSkippingQuestion"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col-md-5 d-flex justify-content-end max-space-height px-0"
                        >
                          <div class="p-0 text-md-end">Allow Review of Answers ?</div>
                        </div>
                        <div class="col-md-6 max-space-height">
                          <input
                            type="checkbox"
                            formControlName="allowReviewAnswers"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col-md-5 d-flex justify-content-end max-space-height px-0"
                        >
                          <div class="p-0 text-md-end">Random Question Order ?</div>
                        </div>
                        <div class="col-md-6 max-space-height">
                          <input
                            type="checkbox"
                            formControlName="randomQuestionOrder"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-5 d-flex max-space-height justify-content-md-end">
                          <div class="p-0 text-md-end">Total Test Score</div>
                        </div>
                        <div class="col-md-6 max-space-height">
                          <input
                            type="text"
                            formControlName="totalTestScore"
                            [min]="0"
                            onKeyPress="if(this.value.length==10) return false;"
                            [appTwoDigitDecimaNumber]="2"
                            class="form-control form-control-sm input-txt text-md-end"
                            [ngClass]="addCourseForm.get('totalTestScore')?.touched && addCourseForm.get('totalTestScore')?.invalid ? 'red-border-required' : ''"
                          />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-5 d-flex max-space-height justify-content-md-end">
                          <div class="p-0 text-md-end">Cut of Score</div>
                        </div>
                        <div class="col-md-6 max-space-height">
                          <input
                            type="text"
                            formControlName="cutOfScore"
                            onKeyPress="if(this.value.length==10) return false;"
                            [appTwoDigitDecimaNumber]="2"
                            class="form-control form-control-sm input-txt text-md-end"
                            [ngClass]="addCourseForm.get('cutOfScore')?.touched && addCourseForm.get('cutOfScore')?.invalid ? 'red-border-required' : ''"
                          />
                        </div>
                      </div>


                  <div class="row">
                    <div class="col-md-5 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Pass Rate %</div>
                    </div>
                    <div class="col-md-6 max-space-height ">
                      <input
                        type="text"
                        formControlName="passRate"
                        [appTwoDigitDecimaNumber]="4"
                        onKeyPress="if(this.value.length==10) return false;"

                        [min]="0"
                        class="form-control form-control-sm input-txt text-md-end"
                        [ngClass]="addCourseForm.get('passRate')?.touched && addCourseForm.get('passRate')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>




                    </div>
                  </div>
                </div>
              </div>
            </div>
<!-- Third column -->
            <div class="col-md-6">
              <div class="row" style="margin-top: 6px;">
                <div class="col-md-6 ">

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Highest Score %</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="highestScorePercentage"
                        [appTwoDigitDecimaNumber]="2"
                        onKeyPress="if(this.value.length==10) return false;"
                        [min]="0"

                        class="form-control form-control-sm input-txt text-md-end"
                        [ngClass]="addCourseForm.get('highestScorePercentage')?.touched && addCourseForm.get('highestScorePercentage')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Number of Registrations</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="number"
                        formControlName="numberOfRegistrations"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                        [ngClass]="addCourseForm.get('numberOfRegistrations')?.touched && addCourseForm.get('numberOfRegistrations')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Exam Passed Count</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="number"
                        formControlName="examPassedCount"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                        [ngClass]="addCourseForm.get('examPassedCount')?.touched && addCourseForm.get('examPassedCount')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Number of Answer Choices</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="number"
                        formControlName="numberOfAnswerChoices"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                        [ngClass]="addCourseForm.get('numberOfAnswerChoices')?.touched && addCourseForm.get('numberOfAnswerChoices')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end position-relative">
                      <div class="p-0 text-md-end">Answer Numbering Level</div>
                      <div class="p-0  postion-absolute answer-numbering-level">*</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <select
                        class="form-control form-control-sm inputfield-txt"
                        formControlName="answeringNumberLevel"
                        [ngClass]="addCourseForm.get('answeringNumberLevel')?.touched && addCourseForm.get('answeringNumberLevel')?.invalid ? 'red-border-required' : ''"
                      >
                        <option hidden></option>
                        <option
                          class="border-bottom"
                          *ngFor="let code of answeringNumberingType"
                          [value]="code.Code"
                        >
                          {{ code.Description }}
                        </option>
                      </select>
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Number of Questions</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="number"
                        formControlName="numberOfQuestion"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                        [ngClass]="addCourseForm.get('numberOfQuestion')?.touched && addCourseForm.get('numberOfQuestion')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col-md-6 d-flex max-space-height justify-content-md-end"
                    >
                      <div class="p-0 text-md-end">
                        Fixed Right Answer Score ?
                      </div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        (change)="fixedRightAnswerScoreChange($event)"
                        type="checkbox"
                        formControlName="fixedRightAnswerScore"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Right Answer Default Score</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="text"
                        formControlName="rightAnswerDefaultScore"
                        onKeyPress="if(this.value.length==10) return false;"
                        [appTwoDigitDecimaNumber]="2"
                        class="form-control form-control-sm input-txt text-md-end"
                        [ngClass]="addCourseForm.get('rightAnswerDefaultScore')?.touched && addCourseForm.get('rightAnswerDefaultScore')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>


                  <div class="row">
                    <div
                      class="col-md-6 d-flex max-space-height justify-content-md-end"
                    >
                      <div class="p-0 text-md-end">
                        Fixed Wrong Answer Score ?
                      </div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="checkbox"
                        (change)="fixedWrongtAnswerScoreChange($event)"
                        formControlName="fixedWrongAnswerScore"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Wrong Answer Default Score</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="text"
                      formControlName="wrongAnswerDefaultScore"
                        mask="separator"
                        [allowNegativeNumbers]="true"
                        [max]="999999"
                        maxlength="10"
                        class="form-control form-control-sm input-txt text-md-end"
                        [ngClass]="addCourseForm.get('wrongAnswerDefaultScore')?.touched && addCourseForm.get('wrongAnswerDefaultScore')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end"> Unattempted Answer Default Score</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="text"
                      formControlName="unattemptedAnswerDefaultScore"
                        mask="separator"
                        [allowNegativeNumbers]="true"
                        [max]="999999"
                        maxlength="10"
                        class="form-control form-control-sm input-txt text-md-end"
                        [ngClass]="addCourseForm.get('unattemptedAnswerDefaultScore')?.touched && addCourseForm.get('unattemptedAnswerDefaultScore')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-6 d-flex max-space-height justify-content-md-end"
                    >
                      <div class="p-0 text-md-end">
                        Fixed Answering Time ?
                      </div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="checkbox"
                        (change)="fixedAnsweringTimeChange($event)"
                        formControlName="fixedAnsweringTime"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Time to Answer in seconds</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="number"
                        mask="separator"
                        [allowNegativeNumbers]="true"
                        formControlName="TimeToAnswerInSeconds"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                        [ngClass]="addCourseForm.get('TimeToAnswerInSeconds')?.touched && addCourseForm.get('TimeToAnswerInSeconds')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col-md-6 d-flex max-space-height justify-content-md-end"
                    >
                      <div class="p-0 text-md-end">
                        Allow Optional Questions ?
                      </div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="checkbox"
                        (change)="allowOptionalQuestionChange($event)"
                        formControlName="allowOptionalQuestion"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex max-space-height justify-content-md-end">
                      <div class="p-0 text-md-end">Number of Optional Questions</div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="number"
                        formControlName="numberOfOptionalQuestion"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                        [ngClass]="addCourseForm.get('numberOfOptionalQuestion')?.touched && addCourseForm.get('numberOfOptionalQuestion')?.invalid ? 'red-border-required' : ''"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-6 d-flex max-space-height justify-content-md-end"
                    >
                      <div class="p-0 text-md-end">
                        No. of Optional Questions to be Answered
                      </div>
                    </div>
                    <div class="col-md-6 max-space-height ps-0">
                      <input
                        type="number"
                        formControlName="numberOfOptionalQuestionToBeAnswered"
                        onKeyPress="if(this.value.length==10) return false;"
                        (keypress)="preventEnteringString($event, 10)"
                        class="form-control form-control-sm input-txt"
                      />
                      <div *ngIf="addCourseForm.hasError('maxValueError')">
                        <small class="text-danger">
                          No. of Optional Questions to be Answered cannot be greater than Number of Optional Questions.
                        </small>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div
                      class="col-md-4  d-flex align-items-center justify-content-end max-space-height"
                    >
                    <label class="py-0 position-relative text-md-end">Course Image<span class="p-0 label-red required-star ms-1">*</span></label>

                    </div>
                    <div class="col-md-6 px-md-0 max-space-height">
                      <div class="d-flex justify-content-start">
                        <button
                          type="button"
                          (click)="uploadCourseImage.click()"
                          class="btn btn-sm bg-light border"
                          *ngIf="addCourseForm.value.courseImageDeletedInd ==='Y'|| !addCourseForm.value.courseImageFileNameInServer"
                        >
                          Browse
                        </button>

                        <input
                          type="file"
                          hidden
                          accept=".jpg,.jpeg,.png"
                          #uploadCourseImage
                          (change)="
                            imageHandle($event, 'file1', 'previewFile1')
                          "
                        />
                        <img
                          class="image-object-fit"
                          [src]="
                            (addCourseForm.value.courseImageDeletedInd ==='N' && addCourseForm.value.courseImageFileNameInServer)
                              ? (env.env === 'local' ? env.apiBaseUrl : '') +
                                addCourseForm.value
                                  .courseImageFileLocationName +
                                '/' +
                                addCourseForm.value.courseImageFileNameInServer
                              : addCourseForm.value.previewFile1
                              ? addCourseForm.value.previewFile1
                              : '/assets/images/default_image.PNG'
                          "
                          alt=""
                          width="100"
                          height="100"

                        />
                        <div>
                          <i
                            class="fa fa-trash p-2"
                            title="Delete Course Image"
                            style="
                              top: 1.3em;
                              position: relative;
                              font-size: x-large;
                              color: red;
                            "
                            (click)="deleteImage('courseImageDeletedInd','file1')"
                            *ngIf="addCourseForm.value.courseImageDeletedInd==='N' && addCourseForm.value.courseImageFileNameInServer"
                          ></i>
                          <i
                            class="fa fa-times p-2"
                            title="Discard Uploaded Image"
                            style="
                              top: 1.2em;
                              position: relative;
                              font-size: x-large;
                            "
                            *ngIf="addCourseForm.value.file1"
                            (click)="clearUploadImage('file1', 'previewFile1')"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-4 py-0 d-flex align-items-center justify-content-end max-space-height"
                    >
                    <label class="py-0 position-relative text-md-end">Course Icon Image<span class="p-0 label-red required-star ms-1">*</span></label>

                    </div>
                    <div class="col-md-8 px-md-0 max-space-height">
                      <div class="d-flex justify-content-start">
                        <button
                          type="button"
                          (click)="uploadCourseIconImage.click()"
                          class="btn btn-sm bg-light border"
                          *ngIf="
                            addCourseForm.value.courseIconImageDeletedInd ==='Y' || !addCourseForm.value.courseIconImageFileNameInServer
                          "
                        >
                          Browse
                        </button>

                        <input
                          type="file"
                          hidden
                          #uploadCourseIconImage
                          accept=".jpg,.jpeg,.png"
                          (change)="imageHandle($event, 'file2', 'previewFile2')"
                        />

                        <img
                          class="image-object-fit"
                          [src]="
                            addCourseForm.value.courseIconImageDeletedInd ==='N' && addCourseForm.value.courseIconImageFileNameInServer
                              ? (env.env === 'local'
                                  ? env.apiBaseUrl
                                  : '') +
                                addCourseForm.value
                                  .courseIconImageFileLocationName +
                                '/' +
                                addCourseForm.value
                                  .courseIconImageFileNameInServer
                              : addCourseForm.value.previewFile2
                              ? addCourseForm.value.previewFile2
                              : '/assets/images/default_image.PNG'
                          "
                          alt="course icon image"
                          width="100"
                          height="100"

                        />
                        <div>
                          <i
                            class="fa fa-trash p-2 color: red;"
                            title="Delete Course Icon Image"
                            (click)="
                              deleteImage('courseIconImageDeletedInd','file2')
                            "
                            style="
                              top: 1.2em;
                              position: relative;
                              font-size: x-large;
                              color: red;
                            "
                            *ngIf="
                              addCourseForm.value
                                .courseIconImageDeletedInd==='N' && addCourseForm.value.courseIconImageFileNameInServer
                            "
                          ></i>
                          <i
                            class="fa fa-times p-2"
                            title="Discard Uploaded Image"
                            style="
                              top: 1.2em;
                              position: relative;
                              font-size: x-large;
                            "
                            *ngIf="addCourseForm.value.file2"
                            (click)="
                              clearUploadImage('file2', 'previewFile2')
                            "
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-4  d-flex align-items-center justify-content-end max-space-height"
                    >
                      <div class="p-0 text-md-end">Syllabus Document</div>
                    </div>
                    <div class="col-md-8 p-0 max-space-height">
                      <div class="d-flex justify-content-start">
                        <button
                          type="button"
                          (click)="uploadSyllabusIconImage.click()"
                          class="btn btn-sm bg-light border"
                          *ngIf="addCourseForm.value?.syllabusDeletedInd ==='Y' ||!addCourseForm.value.syllabusFileNameInServer"
                        >
                          Browse
                        </button>

                        <input
                          type="file"
                          hidden
                          #uploadSyllabusIconImage
                          [accept]="'application/pdf'"
                          (change)="imageHandle($event, 'file3', '')"

                        />
                        <img
                          [src]="'/assets/images/pdf_default.PNG'"
                          alt="pdf"
                          width="100"
                          height="100"

                        />
                        <div class="">
                          <div>
                            <i
                              class="fa fa-times p-2"
                              title="Discard Uploaded Document"
                              *ngIf="addCourseForm.value.file3"
                              style="
                                top: 1.2em;
                                position: relative;
                                font-size: x-large;
                              "
                              (click)="clearUploadImage('file3', '')"
                            ></i>
                            <i
                              class="fa fa-trash p-1 "
                              title="Delete Course Syllabus"
                              (click)="deleteImage('syllabusDeletedInd','file3')"
                              style="
                                top: 1.2em;
                                position: relative;
                                font-size: x-large;
                                color: red;
                              "
                              *ngIf="
                                addCourseForm.value
                                .syllabusDeletedInd==='N' && addCourseForm.value.syllabusFileNameInServer
                              "
                            ></i>
                            <br />
                            <i
                              class="fa fa-file-pdf-o p-1"
                              style="
                                top: 1.2em;
                                position: relative;
                                font-size: x-large;
                              "
                              title="Preview Course Syllabus"
                              *ngIf="
                                addCourseForm.value.syllabusFileNameInServer && addCourseForm.value
                                .syllabusDeletedInd==='N'
                              "
                              (click)="
                                openPdf(
                                  (env.env === 'local'
                                    ? env.apiBaseUrl
                                    : '') +
                                    addCourseForm.value
                                      .syllabusFileLocationName +
                                    '/' +
                                    addCourseForm.value
                                      .syllabusFileNameInServer
                                )
                              "
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                                    <div class="row">
                    <div
                      class="col-md-4  d-flex align-items-center justify-content-end max-space-height"
                    >
                      <div class="p-0 text-md-end">Exam Instructions</div>
                    </div>
                    <div class="col-md-8 p-0 max-space-height">
                      <div class="d-flex justify-content-start">
                        <button
                          type="button"
                          (click)="examInstructionsFile.click()"
                          class="btn btn-sm bg-light border"
                          *ngIf="addCourseForm.value?.examInstructionDeletedInd ==='Y' ||!addCourseForm.value.examInstructionFileNameInServer"
                        >
                          Browse
                        </button>

                        <input
                          type="file"
                          hidden
                          #examInstructionsFile
                          [accept]="'application/pdf'"
                          (change)="imageHandle($event, 'file4', '')"

                        />
                        <img
                          [src]="'/assets/images/pdf_default.PNG'"
                          alt="pdf"
                          width="100"
                          height="100"

                        />
                        <div class="">
                          <div>
                            <i
                              class="fa fa-times p-2"
                              title="Discard Uploaded Document"
                              *ngIf="addCourseForm.value.file4"
                              style="
                                top: 1.2em;
                                position: relative;
                                font-size: x-large;
                              "
                              (click)="clearUploadImage('file4', '')"
                            ></i>
                            <i
                              class="fa fa-trash p-1 "
                              title="Delete Exam Instructions"
                              (click)="deleteImage('examInstructionDeletedInd','file4')"
                              style="
                                top: 1.2em;
                                position: relative;
                                font-size: x-large;
                                color: red;
                              "
                              *ngIf="
                                addCourseForm.value
                                .examInstructionDeletedInd==='N' && addCourseForm.value.examInstructionFileNameInServer
                              "
                            ></i>
                            <br />
                            <i
                              class="fa fa-file-pdf-o p-1"
                              style="
                                top: 1.2em;
                                position: relative;
                                font-size: x-large;
                              "
                              title="Preview  Exam Instructions"
                              *ngIf="
                                addCourseForm.value.examInstructionFileNameInServer && addCourseForm.value
                                .examInstructionDeletedInd==='N'
                              "
                              (click)="
                                openPdf(
                                  (env.env === 'local'
                                    ? env.apiBaseUrl
                                    : '') +
                                    addCourseForm.value
                                      .examInstructionFileLocationName +
                                    '/' +
                                    addCourseForm.value
                                      .examInstructionFileNameInServer
                                )
                              "
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-12 mt-lg-2">
          <div class="row">
            <div class="col-md-8">
              <div class="row">
            <div class="col-md-2 d-flex justify-content-md-end text-md-end px-xxl-3 ">
              <div class="pt-3">Course Description</div>
            </div>

            <div class="col-md-10 max-space-height px-1" style="padding: 0 3px;">
<div class="d-flex flex-wrap justify-content-between mb-2">
  <div class="border p-2 rounded d-flex justify-content-between align-items-center mb-2 w-100">

    <!-- Course description -->
    <div class="course-description" [innerHTML]="truncatedDescription"></div>

    <div class="d-flex gap-2">
      <!-- Edit button -->
      <button
        *ngIf="addCourseForm.get('description')?.value"
        type="button"
        class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
        (click)="openDescritionEditor()"
      >
        <i class="fa fa-pencil"></i> Edit
      </button>

      <!-- Preview button -->
      <button
        *ngIf="addCourseForm.get('description')?.value"
        type="button"
        class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
        (click)="previewTextDisplayFLag = true"
      >
        <i class="fa fa-eye"></i> Preview
      </button>

      <!-- Add button -->
      <button
        *ngIf="!addCourseForm.get('description')?.value"
        type="button"
        class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
        (click)="openDescritionEditor()"
      >
        <i class="fa fa-plus"></i> Add
      </button>
    </div>
  </div>
</div>

                      <div
              class="row"
            >
              <div class="col-md-12">
                <div class="d-flex flex-wrap justify-content-end">
                  <span>
                    <button
                      class="btn btn-sm bl-btn"

                    >
                      <span class="text-light">Save</span>
                    </button>
                  </span>
                  <span class="mx-2">
                    <button
                      type="button"

                      (click)="clear()"
                      class="btn btn-sm bg-light border"
                    >
                      Cancel
                    </button>

                  </span>

                  <span
                    class="mx-2"

                  >
                  <button
                  type="button"
                  (click)="showCourseAvailableFeatures()"
                  class="btn btn-sm bg-light border"
                  >
                  Available Course Features
                </button>
                  </span>
                  <span
                    class="mx-2"
                    *ngIf="examAgencyRequestParam.courseId"
                  >
                    <button
                      type="button"

                      (click)="
                        courseSubjectFlag = !courseSubjectFlag;
                        visibleInto()
                      "
                      class="btn btn-sm bg-light border"
                    >
                      Course Subject
                    </button>
                  </span>
                </div>
              </div>
            </div>
              <!-- <editor
                [init]="tinyConfig"
                formControlName="description"
              ></editor> -->
            </div>
          </div>
          </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>

<section *ngIf="courseSubjectFlag">
  <div>
    <div class="modal fade show Model_popup1">
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-Question-add d-flex justify-content-center"
      >
        <div class="modal-content" style="width: 90em">
          <div class="modal-header border Page-Header p-1 py-0">
            <h6 class="HeadContent" id="QuestionTemplatetitle">
              Course Subject
            </h6>
            <button
              type="button"
              class="close"
              (click)="closeSubject()"
              style="padding-right: 20px; font-size: 30px; outline: 0"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body px-3 py-0">
            <app-exam-instance-subjects-ca
              [courseMasterName]="courseMasterName"
              (onCloseSubject)="onCloseSubject($event)"
              [courseName]="addCourseForm.value.courseName "
              [courseId]="examAgencyRequestParam.courseId"
              [examYear]="addCourseForm.value.examYear"
              [courseMasterId]="examAgencyRequestParam.courseMasterId"
              [examAgencyId]="examAgencyRequestParam.examAgencyId"
            ></app-exam-instance-subjects-ca>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section>
  <app-preview-text
    [previewDialogDisplayFlag]="previewTextDisplayFLag"
    [previewText]="addCourseForm.value.description"
    (displayOff)="displayDialogOff()"
  ></app-preview-text>
</section>

<section class=" my-2" *ngIf="examAgencyRequestParam.courseId">
 <div class="container-fluid">
  <div class="row border Page-Header">
    <div class="col-md-12 ">
      <h6 class="HeadContent d-flex align-items-center">
        <span>Course Plan </span>
        <span title="Add Course Plan" (click)="addCoursePlan()">
          <i class="fa fa-plus-circle plus-icon ms-3 fs-2 pointer-cursor"></i>
        </span>
      </h6>
    </div>
  </div>
</div>
  <div class="container">
    <div class="row">

      <ng-container *ngIf="examAgencyRequestParam.courseId && coursePlans?.length ; else nocontent"  >
      <div class="col-md-12 mt-3 mb-2">
        <table class="table table-bordered table-hover table-striped">
          <thead class="thead-light">
            <!-- Course Plans Header -->
            <tr>
              <th>Details</th>
              <ng-container *ngFor="let item of coursePlans">
                <th class="text-center">
                  <h4>{{ item.Course_Plan_Name }}</h4>
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <!-- General Course Details -->
            <tr>
              <td>Available Date</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">{{ item.Course_Plan_Available_Date | date }}</td>
              </ng-container>
            </tr>
            <tr>
              <td>Standard Price</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <span>{{ item.Course_Plan_Standard_Price | number : '1.2-2' }}</span>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td>Offer Price</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <span>{{ item?.Course_Plan_Current_Offer_Price| number : '1.2-2' }}</span>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td>Offer Price End Date</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <span>{{ item?.Course_Plan_Current_Offer_Price_End_Date| date }}</span>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td>Trail Days</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">{{ item.Trial_Number_Of_Days }}</td>
              </ng-container>
            </tr>
            <tr>
              <td>Best Value?</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <span class="badge" [ngClass]="{'bg-success': item.Best_Value_Ind === 'Y', 'bg-secondary': item.Best_Value_Ind !== 'Y'}">
                    {{ item.Best_Value_Ind === "Y" ? "Yes" : "No" }}
                  </span>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td>Upgradable?</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <span class="badge" [ngClass]="{'bg-success': item.Upgradable_Ind === 'Y', 'bg-secondary': item.Upgradable_Ind !== 'Y'}">
                    {{ item.Upgradable_Ind === "Y" ? "Yes" : "No" }}
                  </span>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td>Course Duration</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">{{ item?.Course_Plan_Duration_Type_Name   }}</td>
              </ng-container>
            </tr>
            <tr>
              <td>No. of Questions Included</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">{{ item.Number_Of_Questions_Incuded }}</td>
              </ng-container>
            </tr>
            <tr>
              <td>Released?</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <span class="badge" [ngClass]="{'bg-success': item.Released_Ind === 'Y', 'bg-secondary': item.Released_Ind !== 'Y'}">
                    {{ item.Released_Ind === "Y" ? "Yes" : "No" }}
                  </span>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td>No. of Flash Cards Included</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">{{ item.Number_Of_Flashcards_Included }}</td>
              </ng-container>
            </tr>

            <!-- Plan Features Section -->
            <tr>
              <td [attr.colspan]="coursePlans.length + 1" class="bg-light">
                <h5 class="text-center">Plan Features</h5>
              </td>
            </tr>
            <tr *ngFor="let itemName of courseFeatureType; let i = index">
              <td>{{ itemName.Description }}</td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <span class="badge" style="font-weight:500; font-size: 16px; " [ngClass]="{'text-black': item.courseFeatureTypeNames[i].isActive, 'bg-secondary': !item.courseFeatureTypeNames[i].isActive}">
                    {{ item.courseFeatureTypeNames[i]?.Feature_Value  }}
                  </span>
                </td>
              </ng-container>
            </tr>

            <!-- Edit Buttons -->
            <tr>
              <td></td>
              <ng-container *ngFor="let item of coursePlans">
                <td class="text-center">
                  <button type="button" (click)="addCoursePlanFeatures(item.Course_Plan_Id)" class="btn btn-sm btn-outline-primary">
                    <i class="fa fa-pencil"></i> Edit
                  </button>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>


      </div>
    </ng-container>
    <ng-template #nocontent>
      <div class="d-flex justify-content-center mt-2">
      No Content
    </div>
    </ng-template>
    </div>
  </div>
</section>
